document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (e) => {
    if (e.target.matches('.an--quantity-swapper.an-inputclass')) {
      const options = Array.from(document.querySelectorAll('.an--quantity-swapper.an-inputclass'));
      const index = options.indexOf(e.target);
      const prescription_data = [
        {burn: 2,balance: 2,build: 1},
        {burn: 2,balance: 2,build: 1},
        {burn: 3,balance: 1,build: 1},
        {burn: 3,balance: 2,build: 1},
        {burn: 3,balance: 2,build: 1}
      ]
      const burnBlock = document.querySelector('.burn-data-js-rendering')
        const balanceBlock = document.querySelector('.balance-data-js-rendering');
      const buildBlock = document.querySelector('.build-data-js-rendering');

      burnBlock.innerHTML = prescription_data[index].burn;
        balanceBlock.innerHTML = prescription_data[index].balance;
      buildBlock.innerHTML = prescription_data[index].build;
      
      burnBlock.classList.add('an--popup-text-on-change');  
        balanceBlock.classList.add('an--popup-text-on-change');
      buildBlock.classList.add('an--popup-text-on-change');

      // document.querySelector('.box-1').classList.add('an--popup-text-on-change')
      // document.querySelector('.box-2').classList.add('an--popup-text-on-change')
      // document.querySelector('.box-3').classList.add('an--popup-text-on-change')

      setTimeout(()=>{
        burnBlock.classList.remove('an--popup-text-on-change');
          balanceBlock.classList.remove('an--popup-text-on-change');
        buildBlock.classList.remove('an--popup-text-on-change');
      // document.querySelector('.box-1').classList.remove('an--popup-text-on-change')
      // document.querySelector('.box-2').classList.remove('an--popup-text-on-change')
      // document.querySelector('.box-3').classList.remove('an--popup-text-on-change')
      }, 1000)

    }
  });
});